import React, { Children, Component } from "react";
import PropTypes from "prop-types";
import {
  reduxForm,
  getFormAsyncErrors,
  getFormSyncErrors,
  getFormSubmitErrors,
  change,
} from "redux-form";
//formValueSelector,
import { connect } from "react-redux";
import compose from "recompose/compose";
import { Tabs, Tab } from "material-ui/Tabs";
import muiThemeable from "material-ui/styles/muiThemeable";
import Snackbar from "material-ui/Snackbar";
import { red500 } from "material-ui/styles/colors";
import { Toolbar } from "admin-on-rest";
import { ValuesForm } from "../../components";
import getDefaultValues from "../../components/form/getDefaultValues";
import FormPage from "./FormPage";
import { RestApiShortUrl } from "../../restClient";

const getStyles = (theme) => ({
  form: { padding: "0 1em 3em 1em" },
  // TODO: The color will be taken from another property in MUI 0.19 and later
  errorTabButton: { color: theme.textField.errorColor },
});

export class TabbedForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      nickname: props.record.nickname || "",
      open: false,
      message: "The Slug already have",
    };
  }
  componentWillMount() {}

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  handleChange = (value) => {
    this.setState({ value });
  };

  handleSubmitWithRedirect = (redirect = this.props.redirect) =>
    this.props.handleSubmit((values) => {
      if (this.state.nickname === values.nickname) {
        this.props.save(values, redirect);
      } else {
        this.getSlug(values, redirect);
      }
    });

  getSlug = (values, redirect) => {
    RestApiShortUrl(values.nickname)
      .then((response) => {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.json();
      })
      .then((data) => {
        if (!data.exists) {
          this.props.save(values, redirect);
        } else {
          this.props.showNotification("The Slug already have", "warning");
        }
      })
      .catch((e) => {
        this.props.showNotification("Please try again", "warning");
        console.error(e);
      });
  };

  render() {
    const {
      children,
      contentContainerStyle,
      invalid,
      muiTheme,
      submitOnEnter,
      tabsWithErrors,
      toolbar,
      translate,
      version,
    } = this.props;

    const styles = getStyles(muiTheme);
    return (
      <div>
        <form className="tabbed-form">
          <div style={styles.form} key={version}>
            <Tabs
              value={this.state.value}
              onChange={this.handleChange}
              contentContainerStyle={contentContainerStyle}
            >
              <Tab
                className="form-tab"
                label={"main"}
                value={0}
                buttonStyle={
                  tabsWithErrors.includes("main") && this.state.value !== 0
                    ? styles.errorTabButton
                    : null
                }
              >
                {React.cloneElement(children, {
                  translate,
                  ...this.props,
                })}
              </Tab>
              <Tab
                className="form-tab"
                label={"page"}
                value={1}
                buttonStyle={
                  tabsWithErrors.includes("page") && this.state.value !== 1
                    ? styles.errorTabButton
                    : null
                }
              >
                <FormPage
                  label={"page"}
                  {...this.props}
                  tabIndex={this.state.value}
                />
                {/* <FormVariants label={"variants"} {...this.props} /> */}
              </Tab>
            </Tabs>
          </div>
          {toolbar &&
            React.cloneElement(toolbar, {
              handleSubmitWithRedirect: this.handleSubmitWithRedirect,
              invalid,
              submitOnEnter,
            })}
        </form>
        <ValuesForm isDebug={true} formName={"record-form"} />
        <Snackbar
          open={this.state.open}
          message={this.state.message}
          autoHideDuration={4000}
          bodyStyle={{ backgroundColor: red500 }}
          onRequestClose={this.handleRequestClose}
        />
      </div>
    );
  }
}

TabbedForm.propTypes = {
  basePath: PropTypes.string,
  children: PropTypes.node,
  contentContainerStyle: PropTypes.object,
  defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  handleSubmit: PropTypes.func, // passed by redux-form
  invalid: PropTypes.bool,
  muiTheme: PropTypes.object.isRequired,
  record: PropTypes.object,
  redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  resource: PropTypes.string,
  save: PropTypes.func, // the handler defined in the parent, which triggers the REST submission
  submitOnEnter: PropTypes.bool,
  tabsWithErrors: PropTypes.arrayOf(PropTypes.string),
  toolbar: PropTypes.element,
  translate: PropTypes.func,
  validate: PropTypes.func,
  version: PropTypes.number,
};

TabbedForm.defaultProps = {
  contentContainerStyle: { borderTop: "solid 1px #e0e0e0" },
  submitOnEnter: false,
  toolbar: <Toolbar />,
};

// const selector = formValueSelector("record-form");

const collectErrors = (state) => {
  const syncErrors = getFormSyncErrors("record-form")(state);
  const asyncErrors = getFormAsyncErrors("record-form")(state);
  const submitErrors = getFormSubmitErrors("record-form")(state);

  return {
    ...syncErrors,
    ...asyncErrors,
    ...submitErrors,
  };
};

export const findTabsWithErrors = (
  state,
  props,
  collectErrorsImpl = collectErrors
) => {
  const errors = collectErrorsImpl(state);

  return Children.toArray(props.children).reduce((acc, child) => {
    const inputs = Children.toArray(child.props.children);

    if (inputs.some((input) => errors[input.props.source])) {
      return [...acc, child.props.label];
    }

    return acc;
  }, []);
};

const enhance = compose(
  connect(
    (state, props) => {
      const children = Children.toArray(props.children).reduce(
        (acc, child) => [...acc, ...Children.toArray(child.props.children)],
        []
      );

      return {
        tabsWithErrors: findTabsWithErrors(state, props),
        initialValues: getDefaultValues(state, { ...props, children }),
      };
    },
    {
      updateContent: (content) => change("record-form", "content", content),
      updateField: (k, v) => change("record-form", k, v),
    }
  ),
  reduxForm({
    form: "record-form",
    enableReinitialize: true,
  }),
  muiThemeable()
);

export default enhance(TabbedForm);



// WEBPACK FOOTER //
// ./src/marketers/form/TabbedForm.js